module.exports = __webpack_public_path__ + "img/71.8a17869e.jpg";